<script setup>
import { computed } from 'vue';
import { useHead } from '#imports';

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const parsedCodes = computed(() => {
  const raw = props.data?.code || '';
  const results = [];

  const scriptRegex = /<script\b([^>]*)>([\s\S]*?)<\/script>/gi;
  let match;

  while ((match = scriptRegex.exec(raw)) !== null) {
    const [fullTag, attrString, innerHTML] = match;

    const typeMatch = attrString.match(/type=["']?([^"'\s]+)["']?/i);
    const srcMatch = attrString.match(/src=["']?([^"'\s]+)["']?/i);

    results.push({
      type: typeMatch ? typeMatch[1] : 'text/javascript',
      src: srcMatch ? srcMatch[1] : undefined,
      innerHTML: srcMatch ? undefined : innerHTML.trim(),
      key: `custom-code-${props.data.id}-${results.length}`,
    });
  }

  return results;
});

useHead(computed(() => ({
  script: parsedCodes.value,
})));
</script>

<template>
  <div v-if="false"></div>
</template>
